import * as React from 'react';
import classnames from 'classnames';
import { Button } from '@grandvisionhq/common';
import Form from '../Form/Form.js';
import Input from '../Input/Input.js';

const InlineInputForm = ({ onSubmit , content , buttonCaptionLabel , placeholderLabel , className , 'data-t': dataT , submitInProgress =false ,  })=>{
    const [inputValue, setInputValue] = React.useState('');
    const [hasError, setHasError] = React.useState(false);
    if (!content) {
        return null;
    }
    const { type , inputId , validateInput , onInputChange  } = content.inputField;
    const formClass = classnames('inline-input-form', {
        'inline-input-form--error': hasError
    });
    const handleOnChange = ({ value  })=>{
        setInputValue(value);
        onInputChange && onInputChange(value);
    };
    const handleOnSubmit = ()=>{
        if (!inputValue) {
            setHasError(true);
            return;
        }
        if (validateInput && !validateInput(inputValue)) {
            setHasError(true);
            return;
        }
        onSubmit(inputValue);
        setInputValue('');
    };
    const formAnimationEnd = ()=>{
        setHasError(false);
    };
    return /*#__PURE__*/ React.createElement("div", {
        className: formClass,
        onAnimationEnd: formAnimationEnd
    }, /*#__PURE__*/ React.createElement(Form, {
        name: "inline-input",
        className: classnames('inline-input-form__form', className),
        "data-t": dataT,
        onSubmit: handleOnSubmit,
        showErrorsOnInvalidSubmit: false
    }, /*#__PURE__*/ React.createElement(Input, {
        id: inputId,
        className: 'form-control__input inline-input-form__input',
        "data-t": `${dataT}-input`,
        type: type,
        initialValue: inputValue,
        placeholder: placeholderLabel,
        onChange: handleOnChange,
        disabled: submitInProgress
    }), /*#__PURE__*/ React.createElement(Button, {
        size: "custom",
        className: "inline-input-form__button",
        caption: buttonCaptionLabel,
        onClick: handleOnSubmit,
        variant: "outline",
        isLoading: submitInProgress
    })));
};

export { InlineInputForm, InlineInputForm as default };
//# sourceMappingURL=InlineInputForm.js.map
